import axios from "axios";
import { useParams } from "react-router-dom";
import { Quotedata } from "../data.js";
import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

const ConfigForm = () => {
  const { slug } = useParams();
  const [formData, setFormData] = useState({
    left_width: "",
    overall_width: "",
    right_width: "",
    overall_height: "",
    housing_size: "",
    housing_color: "",
    tracks_hardware: "",
    color_hardware: "",
    handle_centered: "",
    handle_like: "",
    mesh_want: "",
    recessed_channel: "",
    recessed_cup: "",
    box_channel: "",
    screen_maintenance_kit: "",
    message: "",
  });

  const [successMessageVisible, setSuccessMessageVisible] = useState(false);

  const successMessageRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [product, setProduct] = useState(null);

  useEffect(() => {
    // Fetch product data based on slug (if needed)
    const foundProduct = Quotedata.find((e) => e.name === slug);
    if (foundProduct) {
      setProduct(foundProduct);
    }
  }, [slug]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that all required fields are filled
    for (const key in formData) {
      if (!formData[key] && key !== "image") {
        alert(`Please fill in the ${key}.`);
        return;
      }
    }

    const data = new FormData();
    // Append all form data to the FormData object
    data.append("left_width", formData.left_width);
    data.append("overall_width", formData.overall_width);
    data.append("right_width", formData.right_width);
    data.append("overall_height", formData.overall_height);
    data.append("housing_size", formData.housing_size);
    data.append("housing_color", formData.housing_color);
    data.append("tracks_hardware", formData.tracks_hardware);
    data.append("color_hardware", formData.color_hardware);
    data.append("handle_centered", formData.handle_centered);
    data.append("handle_like", formData.handle_like);
    data.append("mesh_want", formData.mesh_want);
    data.append("recessed_channel", formData.recessed_channel);
    data.append("recessed_cup", formData.recessed_cup);
    data.append("box_channel", formData.box_channel);
    data.append("screen_maintenance_kit", formData.screen_maintenance_kit);
    data.append("message", formData.message);
    data.append("product_name", product ? product.name : "");

    try {
      // Replace with your actual backend URL
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const response = await axios.post(`${baseUrl}/api/request-quote`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // On success, show the success message
      console.log("API response:", response.data);
      setSuccessMessageVisible(true);

      if (successMessageRef.current) {
        successMessageRef.current.scrollIntoView({ behavior: "smooth" });
      }
    } catch (error) {
      // Handle errors from the API
      if (error.response) {
        console.error("Error submitting form:", error.response.data);
        alert(
          `Error: ${error.response.data.message || "Something went wrong."}`
        );
      } else {
        console.error("Error submitting form:", error.message);
        alert(`Error: ${error.message}`);
      }
    }
  };

  return (
    <div className="main-form">
      <Container>
        {successMessageVisible && (
          <div
            ref={successMessageRef}
            className="alert alert-success"
            role="alert"
          >
            Your Form has been submitted!
          </div>
        )}
        <h6>Configure Form</h6>
        <form className="config-form" onSubmit={handleSubmit}>
          {/* Dimensions */}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Dimensions</h2>
            </div>
            <Row>
              <Col md={6}>
                <label className="laber-form">
                  What is the left width of your unit? *
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    name="left_width"
                    value={formData.left_width}
                    onChange={handleChange}
                  />
                </div>
              </Col>
              <Col md={6}>
                <label className="laber-form">
                  What is the overall width of your unit? *
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    name="overall_width"
                    value={formData.overall_width}
                    onChange={handleChange}
                  />
                </div>
              </Col>
              <Col md={6}>
                <label className="laber-form">
                  What is the right width of your unit? *
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    name="right_width"
                    value={formData.right_width}
                    onChange={handleChange}
                  />
                </div>
              </Col>
              <Col md={6}>
                <label className="laber-form">
                  What is the overall height of your unit? *
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    name="overall_height"
                    value={formData.overall_height}
                    onChange={handleChange}
                  />
                </div>
              </Col>
            </Row>
          </div>

          {/* Housing */}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Housing</h2>
            </div>
            <Row>
              <Col md={6}>
                <label className="laber-form">What housing size? *</label>
                <div className="input-group">
                  <select
                    name="housing_size"
                    value={formData.housing_size}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select Housing Size</option>
                    <option value="60mm">60mm</option>
                    <option value="70mm">70mm</option>
                    <option value="80mm">80mm</option>
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <label className="laber-form">
                  What color of housing finish? *
                </label>
                <div className="input-group">
                  <select
                    name="housing_color"
                    value={formData.housing_color}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select Housing Finish</option>
                    <option value="Black">Black</option>
                    <option value="White">White</option>
                    <option value="Bronze">Bronze</option>
                    <option value="Anodized">Anodized</option>
                    <option value="Sandalwood">Sandalwood</option>
                    <option value="Custom">Custom</option>
                  </select>
                </div>
              </Col>
            </Row>
          </div>

          {/*Tracks & Hardware*/}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Tracks & Hardware</h2>
            </div>
            <Row>
              <Col md={6}>
                <label className="laber-form">
                  Do you already have tracks? *
                </label>
                <div className="input-group">
                  <select
                    name="tracks_hardware"
                    value={formData.tracks_hardware}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select tracks</option>
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <label className="laber-form">What color of hardware? *</label>
                <div className="input-group">
                  <select
                    name="color_hardware"
                    value={formData.color_hardware}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select color of hardware </option>
                    <option value="Black">Black</option>
                    <option value="White">White</option>
                    <option value="Bronze">grey</option>
                  </select>
                </div>
              </Col>
            </Row>
          </div>

          {/*Handle*/}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Handle</h2>
            </div>
            <Row>
              <Col md={6}>
                <label className="laber-form">
                  Which handle do you want centered? (the other one will be
                  placed 4 1/2" below) *
                </label>
                <div className="input-group">
                  <select
                    name="handle_centered"
                    value={formData.handle_centered}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select handle do you want centered</option>
                    <option value="Standard 4 below center">
                      Standard 4" below center
                    </option>
                    <option value="Custom">Custom</option>
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <label className="laber-form">
                  Which handle would you like? *
                </label>
                <div className="input-group">
                  <select
                    name="handle_like"
                    value={formData.handle_like}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select color of hardware </option>
                    <option value="Low Profile Handle">
                      Low Profile Handle
                    </option>
                    <option value="Standerd">Standerd</option>
                  </select>
                </div>
              </Col>
            </Row>
          </div>

          {/*Mesh*/}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Mesh</h2>
            </div>
            <label className="laber-form">What mesh do you want? *</label>
            <div className="input-group">
              <select
                name="mesh_want"
                value={formData.mesh_want}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">Select mesh</option>
                <option value="Charcoal 18x14 Mesh">Charcoal 18x14 Mesh</option>
                <option value="Tuff Mesh Charcoal 17x13">
                  Tuff Mesh Charcoal 17x13
                </option>
                <option value="Tuff No-Seeum 18x22">Tuff No-Seeum 18x22</option>
              </select>
            </div>
          </div>

          {/*Additional*/}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Additional</h2>
            </div>
            <Row>
              <Col md={6}>
                <label className="laber-form">
                  Do you want a Recessed Channel? *
                </label>
                <div className="input-group">
                  <select
                    name="recessed_channel"
                    value={formData.recessed_channel}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select Recessed Channel</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <label className="laber-form">
                  Do you want a Recessed Cup? *
                </label>
                <div className="input-group">
                  <select
                    name="recessed_cup"
                    value={formData.recessed_cup}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select Recessed Cup</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </Col>
            </Row>
          </div>

          {/*Box Channel*/}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Box Channel</h2>
            </div>
            <label className="laber-form">
              Would you like box channel(s)? *
            </label>
            <div className="input-group">
              <select
                name="box_channel"
                value={formData.box_channel}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">Select box channel</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

          {/*Screen Maintenance Kit*/}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Screen Maintenance Kit</h2>
            </div>
            <div className="Screen-Maintenance">
              <span>Screen Maintenance Kit includes:</span>
              <ul>
                <li>1 can of silicone spray</li>
                <li>1 brush cleaning tool</li>
              </ul>
              <p>
                Notice, Screen Maintenance Kit with Silicone Spray and Silicone
                Spray cant be shipped by Air freight, can only be shipped via
                Ground Service
              </p>
            </div>
            <label className="laber-form">
              Would you like a screen maintenance kit? *
            </label>
            <div className="input-group">
              <select
                name="screen_maintenance_kit"
                value={formData.screen_maintenance_kit}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">Select box channel</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

          {/*Notes*/}
          <div className="box-border">
            <div className="dimenshand">
              <h2>Notes</h2>
            </div>
            <label className="laber-form">
              Add here additional notes. For example RAL color request{" "}
            </label>
            <div className="input-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
              ></textarea>
            </div>
          </div>
          <div className="congif-button">
            <button type="submit">Submit</button>
          </div>
        </form>
      </Container>
    </div>
  );
};

export default ConfigForm;
